//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/index'
import { App_User } from '@/data/user_info'

export default {
    data () {
        return {
            name: ''
        }
    },
    mounted () {
        console.log('mounted')
        const { name } = this.$route.query
        this.name = name
        this.getData()
    },
    beforeDestroy () {
        this.name = ''
    },
    computed: {
        title () {
            return `绑定【${ this.name }】的编码`
        }
    },
    methods: {
        getData () {
            App_User.get().then(({ tag_list }) => {
                console.log('tag_list')
                if (tag_list && tag_list.indexOf('天府通游客') > -1) {
                    wx.redirectTo({
                        url: '/logging_in'
                    })
                }
            })
        },
        confirmBind () {
            wx.redirectTo({
                url: '/pages/personal_package/mine/bind'
            })
        },
        submit (e) {
            const { house_id } = this.$route.query
            const { target } = e
            const data = {
                nickname: target.nickname.value,
                register_number: target.register_number.value
            }
            for (let key in data) {
                if (data[key].trim() === '') {
                    wx.showToast({
                        title: '您尚未填写完全',
                        icon: 'none'
                    })
                    return
                }
            }
            data.ln_number = target.ln_number.value
            console.log('addUserNum', data)
            Service.addUserNum(house_id, data).then((data) => {
                console.log('addUserNum', data)
                wx.navigateBack({
                    delta: 1
                })
            })
        }
    },

}
